import { WebApiService } from '../../../../../plugins/webApiService'
import { Events } from '../../../../../plugins/events'
import { SendRequestModel } from '../../../../../plugins/models/SendRequestModel'
import LegalDirectorsSaveDataRequest from '../../../../../identification-services/models/legal-directors/LegalDirectorsSaveDataRequest';
import WsResponseModelT from '../../../../../schema-builder/server/models/WsResponseModelT';
import LegalDirectorsGetDataResponse from '../../../../../identification-services/models/legal-directors/LegalDirectorsGetDataResponse';

export default class LegalDirectorsWsController {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	GetLegalDirectorsEvent = new Events<WsResponseModelT<LegalDirectorsGetDataResponse>>();
	SaveLegalDirectorsDataEvent = new Events<WsResponseModelT<Boolean>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('LegalDirectorsWsController', 'GetLegalDirectors', 'Main', (res: WsResponseModelT<LegalDirectorsGetDataResponse>) => {
			self.GetLegalDirectorsEvent.trigger(res);
		});
		webApiService.on('LegalDirectorsWsController', 'SaveLegalDirectorsData', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.SaveLegalDirectorsDataEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	async GetLegalDirectors() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'LegalDirectorsWsController',
			Method: 'GetLegalDirectors',
		})

		webApiService.send(sendRequest);
	}

	async SaveLegalDirectorsData(request: LegalDirectorsSaveDataRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'LegalDirectorsWsController',
			Method: 'SaveLegalDirectorsData',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	async getLegalDirectorsAsync(): Promise<LegalDirectorsGetDataResponse> {
		return new Promise<LegalDirectorsGetDataResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'LegalDirectorsWsController',
				Method: 'GetLegalDirectors',
				Callback: (response: WsResponseModelT<LegalDirectorsGetDataResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as LegalDirectorsGetDataResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async saveLegalDirectorsDataAsync(request: LegalDirectorsSaveDataRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'LegalDirectorsWsController',
				Method: 'SaveLegalDirectorsData',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}